export default __webpack_public_path__ + "static/media/greg.804f7853.png";